import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProjectVerification } from '../models/projectverification';
import { map } from 'rxjs/operators';
import { ProjectValidationCriteria } from '../../project-intake/models/projectvalidationcriteria';
import { ProjectValidationResponse } from '../models/projectvalidationresponse';
import { ValidationSummaryReportData } from '../models/validationsummaryreportdata';

@Injectable({
  providedIn: 'root'
})
export class VerificationService {
  private projectTitleSource = new BehaviorSubject<string>('');
  currentProjectTitle = this.projectTitleSource.asObservable();

  constructor(private http: HttpClient) { }

  changeProjectTitle(title: string = '') {
    this.projectTitleSource.next(title);
  }


  //Get Project Verification by Project Id details
  GetProjectVerificationByProjectId(projectId: number): Observable<any> {
    const url = `${environment.gateway_url}/getverificationbyidasync/${projectId}`;
    return this.http.get<ProjectVerification>(url);
  }

  //Get Project Verification details by VendorId
  GetProjectVerificationByVendorId(vendorId: number): Observable<any> {
    const url = `${environment.gateway_url}/getprojectverificationbyvendorid/${vendorId}`;
    return this.http.get<ProjectVerification[]>(url);
  }

  //Update Project Verification Status
  UpdateProjectVerificationStatus(verificationData: any): Observable<any> {
    const url = `${environment.gateway_url}/updateverificationstatus`
    return this.http.put(url, verificationData).pipe(
      map(item => item ? item : [])
    );
  }

  ///this is used to delete the project validation criteria in project intake screen
  deleteprojectcriteria(id: number): Observable<any> {
    const url = `${environment.gateway_url}/deleteprojectcriteria/${id}`
    return this.http.get(url).pipe(
      map(item => item ? item : [])
    );
  }

  //Get Project Verification details by projectId
  getProjectValidationCriterias(projectId: number): Observable<any> {
    const url = `${environment.gateway_url}/getProjectValidationCriterias/${projectId}`;
    return this.http.get<ProjectValidationCriteria[]>(url);
  }

  //Get Project validation responses details by image id
  getProjectValidationResponses(imageId: number): Observable<any> {
    const url = `${environment.gateway_url}/getProjectValidationResponses/${imageId}`;
    return this.http.get<ProjectValidationResponse[]>(url);
  }

  ///this is used to delete the project validation responses
  deleteResponses(imageId: number): Observable<any> {
    const url = `${environment.gateway_url}/deleteResponses/${imageId}`
    return this.http.get(url).pipe(
      map(item => item ? item : [])
    );
  }

  //save validation reponses
  saveProjectValidationResponses(model: any): Observable<any> {
    const url = `${environment.gateway_url}/saveProjectValidationResponses`
    return this.http.post<Observable<any>>(url, model, { withCredentials: false });
  }

  //Validation Summary Report
  GetValidationSummaryReport(inputModel: ValidationSummaryReportData): Observable<any> {    
      const url = `${environment.gateway_url}/exportvalidationsummary`;
  
      return this.http.post(url, inputModel, {
        responseType: 'blob',
        observe: 'response'
      }).pipe(
        map((res: HttpResponse<Blob>) => {
            const blob = new Blob([res.body!], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            return blob;
        })
      );
    }

}